module.exports = __webpack_public_path__ + "static/media/bar-chart.e66b19a5.svg";